export function isElevatedAdminRole(roles = []) {
    return (
        roles.includes('超級管理員') ||
        roles.includes('系統管理員') ||
        roles.includes('諮詢管理員')
    );
}

export function isConsultantRole(roles = []) {
    return roles.includes('諮詢師');
}

/** 只掛「排班工程師」、沒有管理或諮詢師角色時，進後台只看參數設置 */
export function isBookingEngineerOnly(roles = []) {
    return (
        roles.includes('排班工程師') &&
        !isElevatedAdminRole(roles) &&
        !isConsultantRole(roles)
    );
}

/** 諮詢師（非高階管理員）預設進諮詢工作台 */
export function shouldUseConsultationWorkspaceHome(roles = []) {
    return isConsultantRole(roles) && !isElevatedAdminRole(roles);
}

export function resolveDefaultHomePathFromAdmin(admin) {
    if (!admin) return '/dashboard';
    const roles = admin.roles || [];
    if (isBookingEngineerOnly(roles)) {
        return '/consultation/booking-params';
    }
    if (shouldUseConsultationWorkspaceHome(roles)) {
        return '/consultation-workspace/bookings';
    }
    return '/dashboard';
}

export function getAdminFromStorage() {
    try {
        const raw = localStorage.getItem('adminInfo');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}
